import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { push } from "../../utils/navigation";
import { listClientLocations, saveUrgentCollectionRequest } from "../../actions/homeActions";
import {
  allowUserWithRoles,
  BASE_URL,
  ROLE_Admin,
  ROLE_OfficeUser,
  ROLE_SalesManager,
  ROLE_SuperUser
} from "../../constants";
import { isCollectionExpectedVolumeMet, requestHasError } from "../../utils";
import UrgentRequestConfirmationModal from "../Common/UrgentLocationConfirmationModal";
import UrgetnRequestUploadsAndNotes from "../Common/UrgentRequestUploadsAndNotes";
import UrgentCollections from "./UrgentCollections";
import { withRouter } from "../../utils/withRouter";

const UrgentCollectionRequest = ({ clientLocations, dispatch, siteConfig, locationId, account, driverRuns }) => {
  const [notes, setNotes] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [selectedCollection, setSelectedCollection] = useState(null);
  const [conditionAgreed, setConditionAgreed] = useState(false);
  const [switchedCollection, setSwitchedCollection] = useState(null);
  const [viewModal, setViewModal] = useState(false);
  const [listLoading, setListLoading] = useState(false);

  
  useEffect(() => {
    setListLoading(true);    
    dispatch(listClientLocations("Collection", locationId)).then(() => setListLoading(false));
  }, [locationId]);
  
  const handleFileDelete = ({ image, index }) => {
    let tempFileCollection = [...files];
    tempFileCollection.splice(index, 1);
    setFiles(tempFileCollection);
  };

  const handleFileChange = (fileList) => {
    setFiles([...files, ...fileList]);
  };

  const handleNoteChange = (e) => {
    setNotes(e.currentTarget.value);
  };

  const handleSave = () => {
    if (!selectedCollection) {
      return toastr.error("Please select a location.");
    }
    if (!conditionAgreed) {
      return toastr.error("Please accept terms and conditions.");
    }
    const isOfficeOrSuperUser = allowUserWithRoles(account, [ROLE_SuperUser, ROLE_OfficeUser, ROLE_SalesManager]);

    if (!isOfficeOrSuperUser && _.isEmpty(files)) {
      return toastr.error("Please upload images.");
    }
    setSubmitLoading(true);
    let payLoad = {
      additionalInformation: notes,
      attachments: files,
      locationId: selectedCollection,
    };
    dispatch(saveUrgentCollectionRequest({ payLoad })).then((x) => {
      setSubmitLoading(false);
      if (!requestHasError({ x })) {
        toastr.success("Urgent collection request created.");
        dispatch(push(`${BASE_URL}/client-requests`));
      }
    });
  };

  const handleSelection = (id) => {
    if (selectedCollection && id !== selectedCollection) {
      // show confirmation modal
      setSwitchedCollection(id);
      setViewModal(true);
    } else {
      setSelectedCollection(id); 
      if(isCollectionExpectedVolumeMet({
        list: clientLocations,
        selectedCollection: id,
        autoApproveUrgentRunEstimate: siteConfig && siteConfig.autoApproveUrgentRunEstimate,
      })){
        setConditionAgreed(true);
      }
    }
  };

  const handleTermsAgreementChange = () => {
    setConditionAgreed(!conditionAgreed);
  };

  const handleModalClose = () => {
    setViewModal(false);
    setSwitchedCollection(null);
  };

  const handleUpdateSelectedCollection = () => {
    setSelectedCollection(switchedCollection);
    setSwitchedCollection(null);
    setViewModal(false);
    setConditionAgreed(isCollectionExpectedVolumeMet({
      list: clientLocations,
      selectedCollection: switchedCollection,
      autoApproveUrgentRunEstimate: siteConfig && siteConfig.autoApproveUrgentRunEstimate,
    }));
    setFiles([]);
  };
  
  return (
    <React.Fragment>
      <div className={"row"}>
        <div className={"col-12"} style={{ marginBottom: "24px" }}>
          <h4>Request Urgent Collection</h4>
        </div>
      </div>
      <UrgentCollections
        list={clientLocations}
        handleSelection={handleSelection}
        selectedCollection={selectedCollection}
        handleTermsAgreementChange={handleTermsAgreementChange} 
        conditionAgreed={conditionAgreed} 
        autoApproveUrgentRunEstimate= {siteConfig && siteConfig.autoApproveUrgentRunEstimate}
        expectedVolumeMet={isCollectionExpectedVolumeMet({
          list: clientLocations,
          selectedCollection,
          autoApproveUrgentRunEstimate: siteConfig && siteConfig.autoApproveUrgentRunEstimate,
        })}
        loading={listLoading}
        driverRuns={driverRuns}
      />
      {conditionAgreed && (
        <UrgetnRequestUploadsAndNotes
          handleFileChange={handleFileChange}
          handleFileDelete={handleFileDelete}
          handleNoteChange={handleNoteChange}
          files={files}
          notes={notes}
        />
      )}
      <button
        className={`btn btn-success mobile-full-width mobile-screen-button mb-1 float-right ${
          submitLoading ? "no-pointer-events" : ""
        }`}
        onClick={handleSave}
        disabled={submitLoading}
      >
        {submitLoading ? "Requesting" : "Request an Urgent Collection"}
      </button>
      <UrgentRequestConfirmationModal
        visible={viewModal}
        handleUpdateSelectedCollection={handleUpdateSelectedCollection}
        handleModalClose={handleModalClose}
      />
    </React.Fragment>
  );
};

function mapStateToProps(state, ownProps) {
  const locationId = parseInt(ownProps.routeParams.locationId);
  return {
    clientLocations: state.home && state.home.clientLocations,
    siteConfig: state.apiConfig,
    locationId: isNaN(locationId) ? null : locationId,
    account: state.account,
    driverRuns: state.driverRuns,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(UrgentCollectionRequest));